import React from 'react';
import {Row, Textarea, Button, Icon, Col} from "react-materialize";
import CryptoFunction from "../functions/CryptoFunctions";
import ButtonMy from "./Button";

class PassView extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pass: "**********",
            encrypted: true,
        }
    }

    render() {
        return (
            <div className={'card purple lighten-5'}>
                <div className="card-content">
                    <span>{this.props.name}</span>
                    <Row>
                        <Textarea
                            s={12}
                            className='browser-view-textarea'
                            readonly
                            value={this.state.pass}
                        />
                        <Col s={12}>
                            <Button flat waves="purple"
                                onClick={()=>{
                                    if (this.props.lastKey !== null || this.props.lastKey === "") {
                                        try {
                                            this.setState({
                                                pass: !this.state.encrypted ? "**********" : CryptoFunction.megaHardPizdecDecrypt(this.props.chipher, this.props.lastKey),
                                                encrypted: !this.state.encrypted,
                                            })
                                        } catch (e) {
                                            this.setState({
                                                pass: "**********",
                                                encrypted: true
                                            })
                                        }
                                    }
                                }}
                            >
                                <Icon>{this.state.encrypted ? 'visibility' : 'visibility_off'}</Icon>
                            </Button>
                            <Button flat waves="purple"
                                    onClick={()=>{
                                        this.props.delete(this.props.id, this.props.idI)
                                    }}
                            >
                                <Icon>delete</Icon>
                            </Button>
                        </Col>
                    </Row>

                </div>
            </div>
        )
    }
}

export default PassView;